import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { ColorBoxFilter } from '@vlabs/shared/components/filters-panel/components/color-box-filter/ColorBoxFilter';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';
import st from '../popovers.module.sass';

function LowerAttributesFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { control } = useFormContext();
  const { t } = useSearchPageTranslation();

  return (
    <FilterPopover
      {...props}
      name={['lower_garment_colors', 'lower_garment_types']}
      ref={ref}
    >
      <ColorBoxFilter
        control={control}
        isMulti
        label={t('filters.event_filters.body_attributes.lower_colors')}
        name="lower_garment_colors"
        options={EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.COLORS.raw}
        showResetButton={false}
      />
      <div className={st.Divider} />
      <div>{t('filters.event_filters.body_attributes.lower_type')}</div>
      <div className={st.CheckboxContainer}>
        <ControllableOptionsFilter
          control={control}
          isSearchable={false}
          name="lower_garment_types"
          options={EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.TYPE.raw}
        />
      </div>
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const LowerAttributesFilterPopoverWithRef = forwardRef(LowerAttributesFilterPopover);
export { LowerAttributesFilterPopoverWithRef as LowerAttributesFilterPopover };
